export default {
  title: '运输条款管理',

  search: {
    keyword: '关键词搜索',
    keywordPlaceholder: '条款代码、名称',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    searchButton: '搜索',
    resetButton: '重置'
  },

  actions: {
    addTransportTerm: '新增运输条款',
    batchEnable: '批量启用',
    batchDisable: '批量禁用',
    enable: '启用',
    disable: '禁用',
    recordsCount: '共 {count} 条记录'
  },

  table: {
    termCode: '条款代码',
    termNameCn: '条款名称（中文）',
    termNameEn: '条款名称（英文）',
    description: '描述',
    status: '状态',
    operation: '操作'
  },

  form: {
    addTitle: '新增运输条款',
    editTitle: '编辑运输条款',
    termCode: '条款代码',
    termNameCn: '条款名称（中文）',
    termNameEn: '条款名称（英文）',
    description: '描述',
    status: '状态'
  },

  confirm: {
    enableItem: '确定要启用此运输条款吗？',
    disableItem: '确定要禁用此运输条款吗？'
  },

  messages: {
    selectToAdd: '请选择要添加的运输条款',
    associateSuccess: '成功关联 {count} 个运输条款',
    statusToggleSuccess: '运输条款状态更新成功'
  },

  statusText: {
    enabled: '启用',
    disabled: '禁用'
  },

  modal: {
    title: '从库中选择运输条款',
    confirmText: '确定选择 ({count})',
    statusPlaceholder: '请选择状态'
  }
}